module.exports = __webpack_public_path__ + "img/JF20_Logo1.1e968105.jpg";